import { network } from '../lib/network';
import type { ApiResponse } from '../types/api/network';
import type { VinInspectionsResponse } from '../features/inspections/inspectionTypes';

const excelParams = {
  responseType: 'blob' as const,
  headers: {
    'Content-Type': 'application/xls',
    Accept: 'application/xls',
  },
};

export interface InspectionsListItem {
  [key: string]: unknown;
}

export interface InspectionsListResponse {
  items: InspectionsListItem[];
  meta: {
    totalItems: number;
  };
}

export const InspectionService = {
  getInspections: (params: any, isExcel = false, signal?: AbortSignal): Promise<ApiResponse<InspectionsListResponse | Blob>> => {
    return network.get<InspectionsListResponse | Blob>('/inspections', {
      params,
      signal,
      ...(isExcel ? excelParams : {}),
    });
  },
  getInspectionsByVin: (vin: string, signal?: AbortSignal) => {
    return network.get<VinInspectionsResponse>(`/vin/${encodeURIComponent(vin)}/inspections`, { signal });
  },
  getInspectionAssets: (inspectionId: string, signal?: AbortSignal) => {
    return network.get(`/inspections/${encodeURIComponent(inspectionId)}/assets`, { signal });
  },
  refreshInspectionPlayCookies: (inspectionId: string) => {
    return network.post(`/inspections/${encodeURIComponent(inspectionId)}/play`, {});
  },
  createInspectionStillFrame: (inspectionId: string, params?: any) => {
    return network.post(`/inspections/${encodeURIComponent(inspectionId)}/still-frame`, { ...params });
  },
};
